import { afterNextRender, Component, inject } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment.production';
import { LanguageService } from './services/language.service';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatDialogModule],
  templateUrl: './app.component.html',
})
export class AppComponent {
  private theme = inject(ThemeService);
  private language = inject(LanguageService);

  public constructor() {
    console.log(
      `Angular is using ${environment.production ? 'production' : 'development'} variables`
    );

    // this.config.ripple = true;
    // this.config.setTranslation(primePtBr['pt-br']);

    afterNextRender(() => {
      this.theme.loadCurrentTheme('light');
      this.language.use(this.language.current);
    });
  }
}
